import { normalizeFolderPath } from 'utils/folderPath';

export type FolderNode<T> = {
  name: string;
  path: string;
  children: Map<string, FolderNode<T>>;
  items: T[];
  count: number;
};

const createNode = <T>(name: string, path: string): FolderNode<T> => ({
  name,
  path,
  children: new Map(),
  items: [],
  count: 0,
});

export const buildFolderTree = <T>(
  items: T[],
  getFolderPath: (item: T) => string | null | undefined,
): FolderNode<T> => {
  const root = createNode<T>('', '');

  for (const item of items) {
    root.count++;
    const path = normalizeFolderPath(getFolderPath(item));
    if (path === '') {
      root.items.push(item);
      continue;
    }

    let node = root;
    let currentPath = '';
    for (const segment of path.split('/')) {
      currentPath = currentPath ? `${currentPath}/${segment}` : segment;
      if (!node.children.has(segment)) {
        node.children.set(segment, createNode<T>(segment, currentPath));
      }
      node = node.children.get(segment)!;
      node.count++;
    }
    node.items.push(item);
  }

  return root;
};

export const sortedChildren = <T>(node: FolderNode<T>): FolderNode<T>[] =>
  [...node.children.values()].sort((a, b) => a.name.localeCompare(b.name));
